<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Políticas de entrega cemento</h1>
  <app-politicas-entrega-tabla></app-politicas-entrega-tabla>
</div>
